import React from "react";
import { Loader2, Play, Undo2, ArrowRight } from "lucide-react";
import { assetUrl } from "@/lib/api";

const OP_LABEL = { stabilize: "Stabilize", denoise: "Denoise", sharpen: "Sharpen", upscale: "Upscale ×2" };

const Status = ({ e }) => {
  if (!e) return <span className="chip chip-UNRATED">not run</span>;
  if (e.status === "done") return <span className="chip chip-KEEP">done{e.upscaler ? ` · ${e.upscaler}` : ""}</span>;
  if (e.status === "failed") return <span className="chip chip-REJECTED" title={e.error}>failed</span>;
  return <span className="chip chip-REVIEW"><Loader2 size={10} className="animate-spin" />{e.status}</span>;
};

export const CandidateRow = ({ c, onRun, onRevert, onCompare }) => {
  const e = c.enhancement;
  const busy = e && ["queued", "running"].includes(e.status);
  return (
    <div className="studio-card p-4 flex items-center gap-4 flex-wrap" data-testid={`enh-row-${c.id}`}>
      <img src={assetUrl(c.id, "thumbnail")} alt="" className="w-28 aspect-video object-cover rounded-md bg-black" />
      <div className="flex-1 min-w-[200px] space-y-1">
        <div className="font-semibold text-sm truncate">{c.filename}</div>
        <div className="flex flex-wrap gap-1.5">
          <span className={`chip chip-${c.category || "UNRATED"}`}>{c.category} · {c.score ?? "–"}</span>
          {c.flags.map((f) => <span key={f} className="chip bg-[#252A3B] text-[#94A3B8]">{f}</span>)}
        </div>
        <div className="text-xs text-[#94A3B8]" data-testid={`enh-planned-${c.id}`}>
          {c.planned_ops.length ? c.planned_ops.map((o) => OP_LABEL[o]).join(" + ") : "no enabled ops apply"}
        </div>
      </div>
      <div className="flex flex-col items-end gap-1 min-w-[150px]">
        <Status e={e} />
        {e?.status === "done" && (
          <span className="font-mono text-xs flex items-center gap-1" data-testid={`enh-score-${c.id}`}>
            {e.before_score ?? "–"} <ArrowRight size={11} /> {e.after_score ?? "–"} · {e.resolution}
          </span>
        )}
      </div>
      <div className="flex gap-2">
        {e?.status === "done" && <button className="btn btn-ghost !py-1.5 text-xs" onClick={onCompare} data-testid={`enh-compare-${c.id}`}>Compare</button>}
        {e?.status === "done" && <button className="btn btn-ghost !py-1.5 text-xs" onClick={onRevert} data-testid={`enh-revert-${c.id}`}><Undo2 size={13} />Revert</button>}
        <button className="btn btn-gold !py-1.5 text-xs" onClick={onRun} disabled={busy || !c.planned_ops.length} data-testid={`enh-run-${c.id}`}>
          <Play size={13} />{e?.status === "done" ? "Re-run" : "Enhance"}
        </button>
      </div>
    </div>
  );
};

export const CompareVideos = ({ c, onClose }) => (
  <div className="studio-card p-4 space-y-3" data-testid="enh-compare-panel">
    <div className="flex items-center justify-between">
      <div className="font-semibold text-sm">{c.filename} — original vs enhanced</div>
      <button className="btn btn-ghost !py-1 text-xs" onClick={onClose} data-testid="enh-compare-close">Close</button>
    </div>
    <div className="grid md:grid-cols-2 gap-3">
      {[["proxy", "Original"], ["enhanced", "Enhanced"]].map(([k, l]) => (
        <div key={k}>
          <div className="metric-label mb-1">{l}</div>
          <video src={`${assetUrl(c.id, k)}?v=${c.enhancement?.created_at}`} controls muted loop className="w-full rounded-md bg-black aspect-video" data-testid={`enh-video-${k}`} />
        </div>
      ))}
    </div>
  </div>
);
